import { styled } from '@mui/material/styles';

export const StarSlot = styled('button')(({ theme }) => ({
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
	padding: 0,
	border: 'none',
	background: 'none',
	cursor: 'pointer',
	color: theme.palette.primary.main,

	'&:disabled': {
		cursor: 'default',
	},
}));
